import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import Image from "next/image";
import { getFullUrl } from "../../utils/helper";
type StockListNotFoundProps = {
  headerErrorMessage?: string;
  errorMessage: string;
  isImageVisible?: boolean;
  renderButton?: ReactNode;
  stockNotFoundImgUrl: string;
  imageClassName?: string;
};

const StockListNotFound = (props: StockListNotFoundProps) => {
  const {
    errorMessage,
    isImageVisible = true,
    renderButton,
    headerErrorMessage,
    stockNotFoundImgUrl,
    imageClassName,
  } = props;

  return (
    <section
      className={`flex w-full flex-col items-center justify-center px-[16px] py-[12px] text-center ${!isImageVisible ? "h-[230px]" : ""
        }`}
    >
      {isImageVisible && (
        <Image
          width={142.01}
          height={166.35}          
          src={getFullUrl(stockNotFoundImgUrl)}
          alt="No Stocks Found"
          className={twMerge(
            "box-border h-[166.35px] w-[142.01px] p-[7px_9px_7px_19px] max-md:h-[110.9px] max-md:w-[94.67px] max-md:p-[5px_13px_5px_13px]",
            imageClassName
          )}
          loading="lazy"
        />
      )}
      {headerErrorMessage && (
        <div className="text-lg font-medium text-[#1a1a1a]">
          {headerErrorMessage}
        </div>
      )}
      <p className="mt-3 min-w-[426px] text-base font-normal leading-6 text-[#666666] max-md:min-w-[236px] max-md:text-xs">
        {errorMessage}
      </p>
      {renderButton && (
        <div className="mt-3 flex h-[42px] min-w-[200px] cursor-pointer items-center justify-center rounded-full bg-gradient-to-r from-[#FF6700] to-[#FF8900] px-6 py-3 text-sm font-medium text-white">
          {renderButton}
        </div>
      )}
    </section>
  );
};

export default StockListNotFound;
